// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2Kh3-","title":"AfterImages45_title__mnEJF","images":"AfterImages45_images__2qvY4"};